module.exports = __webpack_public_path__ + "static/media/default.f1baf500.jpeg";